import React, {useState, useEffect} from "react";
import "./index.css";
import Loading from "../loading";
//import diagram from "../../images/apigateway.webp";
import jsdata from "./data.json";


function Article(){

	let [data, setData] = useState([]);
	let [ready, getReady] = useState(false);

	useEffect(()=>{
		setData(jsdata);
		getReady(true);
	}, [])

	return(
		<div className='handlist '>
			{
				!ready ? <Loading /> : data.map(art=>{
					return(
						<article className="handies" key={art.id} data-aos="zoom-in-up" data-aos-duration="500">
							<img src={art.image} alt={`Ibrahim does ${art.headline}`} loading="lazy" />

							<h3 className='arts'>{art.headline}</h3>

							<p className="pleasing">
								{art.context}
							</p>

						</article>

						)
				})
			}

		</div>


		)
}

export default Article;